import { createAction } from '../../../../store.model';
import { ChatMessage } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

export interface SendMessage {
    message: ChatMessage;
}

export const sendMessage = createAction<ActionType, SendMessage>(
    ActionType.COACHING_DETAIL__TCD__SEND_MESSAGE,
);

export interface SendMessageResult extends SendMessage {}

export const sendMessageResult = createAction<ActionType, SendMessageResult>(
    ActionType.COACHING_DETAIL__TCD__SEND_MESSAGE_RESULT,
);
